export default __webpack_public_path__ + "static/4-99e0d2e90f52c70bad119d038fbeaa15.jpeg";